<template>
  <div class="index-box">
    <div class="title-box">
      {{ loginTitle }}
    </div>
    <div class="login-box">
      <div class="login-content password">
        <div class="title">欢迎登录</div>
        <div class="form-box">
          <div class="line input-box">
            <el-input
              placeholder="请输入手机号"
              v-model="phone"
              clearable
              prefix-icon="el-icon-mobile">
            </el-input>
          </div>
          <div class="line input-box">
            <el-input
              placeholder="请输入密码"
              v-model="password"
              show-password
              prefix-icon="el-icon-lock"
              @keypress.enter.native="submit">
            </el-input>
          </div>
        </div>
        <div class="btn-box">
          <el-button class="submit" :disabled="!canLogin" type="primary" @click="submit">登录</el-button>
        </div>
        <div class="register">
          <div class="tips">忘记密码可去小程序更改</div>
          <!-- <span @click="register" class="register-btn">注册</span> -->
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" class="register-dialog" title="账号注册" :visible.sync="dialogVisible"
      width="60%">
      <el-form :disabled="formAable" ref="ruleForm" :model="ruleForm" status-icon :rules="rules" label-width="80px">
        <el-form-item label="用户名" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="ruleForm.password"></el-input>
        </el-form-item>

        <el-form-item label="确认密码" prop="passwordConfirm">
          <el-input v-model="ruleForm.passwordConfirm"></el-input>
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
        </el-form-item>

        <el-form-item label="验证码" prop="verifyCode">
          <el-input v-model="ruleForm.verifyCode"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button :loading="verifyBtnLoading" type="primary" @click="getVerify" :disabled="verifyDisable">{{
            verifyBtnText }}</el-button>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button :disabled="confirmBtnDisable" type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { COOKIE_KEY } from '@/constant';
import axios from 'axios';

export default {
  name: 'Index',

  data() {
    return {
      loginTitle: window.settings.loginTitle || '灯翼智慧照明大数据平台',
      isQr: false,
      phone: '',
      password: '',
      dialogVisible: false,
      formAable: false,
      ruleForm: {
        name: '',
        password: '',
        passwordConfirm: '',
        phone: '',
        verifyCode: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        password: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 必须包含数字、大小写、特殊字符中的三种类型，且长度限制在8～16位
              const reg = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,16}|^(?=.*[0-9])(?=.*[a-z])(?=.*[^A-Za-z0-9]).{8,16}|^(?=.*[0-9])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,16}|^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,16}/;
              console.log('verifyPassword:', value, reg.test(value));
              if (!reg.test(value)) {
                callback(new Error('密码必须包含数字、大小写、特殊字符中的三种类型，且长度限制在8～16位'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        passwordConfirm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.ruleForm.password !== this.ruleForm.passwordConfirm) {
                callback('前后两次密码不一致');
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
              if (!reg.test(value)) {
                callback('请输入正确的手机号');
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      verifyBtnLoading: false,
      verifyDisable: false,
      verifyBtnText: '获取验证码',
      confirmBtnDisable: false,
    };
  },
  computed: {
    canLogin() {
      return this.phone.trim() && this.password;
    },
  },

  mounted() {
  },

  methods: {
    submit() {
      if (this.canLogin) {
        this.doLogin();
      }
    },
    register() {
      console.log('register');
      this.dialogVisible = true;
    },
    getVerify() {
      let myTimer = null;
      const _this = this;
      let delay = 60;
      this.verifyDisable = true;
      // this.verifyBtnText = '3s后重新获取'

      this.verifyBtnLoading = true;

      console.log('getVerify', this.ruleForm);
      // 获取短信验证码
      axios({
        method: 'post',
        url: '/sms/send',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          mobile: this.ruleForm.phone,
        },
      }).then((result) => {
        console.log('getVerify success', result);
        if (result?.data.code === 0) {
          this.$message({
            message: '验证码发送成功，请注意查收。',
            type: 'success',
          });
        }

        // 60s后才能重新获取验证码
        this.timer = setTimeout(() => {
          this.verifyDisable = false;
        }, delay * 1000);

        const countDown = () => {
          if (delay > 0) {
            // eslint-disable-next-line no-plusplus
            delay--;
            _this.verifyBtnText = `${delay}s后重新获取`;
            myTimer = setTimeout(() => {
              countDown();
            }, 1000);
          } else {
            _this.verifyBtnText = '获取验证码';
            myTimer = null;
            clearTimeout(myTimer);
          }
        };
        countDown();
      }).finally(() => {
        this.verifyBtnLoading = false;
      });
    },
    confirm() {
      const resetDisable = () => {
        this.formAable = false;
        this.verifyDisable = false;
        this.confirmBtnDisable = false;
      };
      // 表单校验
      // eslint-disable-next-line consistent-return
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.formAable = true;
          this.verifyDisable = true;
          this.confirmBtnDisable = true;

          // 开始创建注册用户
          axios({
            method: 'post',
            url: '/baoli/create_cdn_user',
            headers: {
              'Content-Type': 'application/json',
            },
            data: {
              mobile: this.ruleForm.phone, // 手机号
              code: this.ruleForm.verifyCode, // 验证码
              name: this.ruleForm.name, // 用户名
              password: this.ruleForm.password, // 密码
            },
          })
            .then((response) => {
              console.log('API response:', response);
              // 注册成功的逻辑
              if (response.data && response.data.res === 'success') {
                this.$message.success('注册成功');
                this.dialogVisible = false; // 关闭对话框
              } else {
                this.$message.error(response.data.message || '注册失败，请重试');
              }
            })
            .catch((error) => {
              // 注册失败的逻辑
              console.error(error);
              this.$message.error('注册失败，请检查网络或稍后再试');
            })
            .finally(() => {
              resetDisable();
            });
        } else {
          this.$message.error('请正确填写表单'); // 验证失败提示
          return false;
        }
      });
    },
    doLogin() {
      const loading = this.$loading();
      const processedPassword = `${this.password}`;
      this.$axios({
        url: '/sys/login',
        methods: 'post',
        data: {
          phone: this.phone,
          password: processedPassword,
        },
      })
        .then((result) => {
          loading.close();
          if (result.data && result.token) {
            Cookies.set(COOKIE_KEY.TOKEN, result.token, { expires: 7 });
            const {
              id, name, photo, role, phone,
            } = result.data;
            const userInfo = {
              id,
              name,
              photo,
              phone,
              role,
            };
            Cookies.set(COOKIE_KEY.USER_INFO, JSON.stringify(userInfo), { expires: 7 });
            this.$message.success('登录成功');
            this.jumpToIndex();
          }
        })
        .catch((e) => {
          loading.close();
          console.error(e);
        });
    },
    jumpToIndex() {
      window.location.href = 'index.html#/';
    },
  },
};
</script>

<style lang="scss" scoped>
.index-box {
  height: 100vh;
  min-height: 400px;
  width: 100%;
  display: flex;
  position: relative;
}

.title-box {
  height: 100%;
  background: url('~@/assets/img/login-bg.png') center;
  background-size: cover;
  color: #fff;
  font-size: 44px;
  padding: 30px 30px 35vh;
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  letter-spacing: 10px;
}

.login-box {
  position: relative;
  z-index: 2;
  flex: 1;
  min-width: 480px;
  background-color: $white;
  padding: 80px 100px;
  border-radius: 4px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-content {
  padding-bottom: 10vh;
  width: 100%;

  .title {
    font-weight: bold;
    font-size: 30px;
    margin-bottom: 50px;
    text-align: left;
  }

  .input-box {
    &+.input-box {
      margin-top: 20px;
    }
  }

  .btn-box {
    margin-top: 50px;

    .submit {
      width: 100%;
    }
  }

  .tips {
    margin-top: 30px;
    font-size: 14px;
    color: $text-secondary;
  }

  .register {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .register-btn {
      display: block;
      color: rgb(37, 89, 235);
      margin-top: 30px;
      font-size: 14px;
      margin-left: 8px;
      cursor: pointer;
    }
  }
}

.register-dialog {
  .el-form-item {
    margin-bottom: 16px;
  }

  .dialog-footer {}
}
</style>
